import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "product-description-text" }
const _hoisted_2 = { class: "product-description-text__headline" }
const _hoisted_3 = {
  key: 0,
  class: "product-description-text__vintage"
}
const _hoisted_4 = { class: "product-description-text__descr1" }
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_read_more = _resolveComponent("read-more")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, [
      (_ctx.productDetails.product.vintage)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.productDetails.product.vintage), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _cache[0] || (_cache[0] = _createTextVNode()),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.description1), 1 /* TEXT */)
    ]),
    _cache[1] || (_cache[1] = _createTextVNode()),
    _createVNode(_component_read_more, {
      "text-more": "ads.main.detail.read_more",
      "text-less": "ads.main.detail.read_less",
      "max-height": 140
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "product-description-text__description",
          innerHTML: _ctx.longDescription
        }, null, 8 /* PROPS */, _hoisted_5)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}